'use client';

import React from 'react';
import { Gem, Shield } from 'lucide-react';

const testimonials = [
  {
    name: "Orlei Mariano",
    role: "Aluno",
    icon: "Gem",
    date: "04/09/2025",
    text: "@Fabrício Silva do mais dificil as duvidas mais 'facil' o cara é monsto!"
  },
  {
    name: "Phelyp",
    role: "Aluno",
    icon: "Gem",
    date: "21/08/2025",
    text: "@Fabrício Silva abriu meus os olhos em poucos minutos consegui resolver um problema de dias. toop demais, valeu"
  },
  {
    name: "Gusthavo",
    role: "Aluno",
    icon: "Gem",
    date: "10/09/2025",
    text: "@Fabrício Silva passando aqui para agradecer ao Fabrício, um cara realmente paciente. Em menos de 5 minutos corrigimos o erro em um fluxo do cliente. Muito obrigado pelo suporte eficiente!"
  },
  {
    name: "Kleber Milton",
    role: "Aluno",
    icon: "Gem",
    date: "13/10/2025",
    text: "Quero expressar minha gratidão ao @Fabrício Silva por mais uma vez ter prestado um suporte de excelência, com toda atenção, paciência e profissionalismo. Sua disposição em ajudar faz toda diferença."
  },
  {
    name: "Rafael Carneiro",
    role: "Aluno",
    icon: "Gem",
    date: "01/09/2025",
    text: "Esqueci de agradecer o @Fabrício Silva na sexta... Mas não podia deixar de vir aqui agradecer depois da AULA que o Fabricio me deu. Me ajudou a colocar um fluxo inteiro pra rodar. Muito obrigado Fabricio, ajudou demais!"
  },
  {
    name: "Mari Peixoto",
    role: "Aluno",
    icon: "Gem",
    date: "03/12/2025",
    text: "Obrigada pelo suporte @Fabricio Silva, salvando como sempre!"
  },
  {
    name: "Dimitry Kirsten",
    role: "Aluno",
    icon: "Gem",
    date: "25/11/2025",
    text: "@Fabricio Silva Obrigado mano!!! atendimento fera, fez toda a diferença hoje."
  },
  {
    name: "Rangel",
    role: "Aluno",
    icon: "Gem",
    date: "06/01/2026",
    text: "@Fabricio Silva me ajudou muito em uma duvida que tive com a conexão mcp. Muito obrigado."
  },
  {
    name: "Giovane",
    role: "Aluno",
    icon: "Gem",
    date: "20/11/2025",
    text: "Muito Obrigado @Fabricio Silva  mesmo no feriado me ajudando com o erro do meu agente.  gratidão "
  },
  {
    name: "Rebecca Martins",
    role: "Aluno",
    icon: "Gem",
    date: "07/11/2025",
    text: "@Fabricio Silva sempre disponível e atencioso. Mais uma vez, obrigada. "
  },
  {
    name: "Marcilene",
    role: "Diretora Comercial Crearte",
    icon: "Gem",
    date: "07/05/2026",
    text: "Quero agradecer ao @Fabrício Silva por toda atenção, cuidado e paciência com a gente. Hoje o dia foi muito Especial, fechamos 3 pedidos pela IA. Sou muito grata por acreditarem na CREARTE e caminharem com a gente."
  }
];

const IconMap = {
  Gem: Gem,
  Shield: Shield
};

export default function TestimonialsSection() {
  // Duplicate testimonials to ensure enough content for the marquee
  const doubledTestimonials = [...testimonials, ...testimonials];

  return (
    <section id="testimonials" className="w-full bg-[#02020c] py-[28px] sm:py-[42px] lg:py-[56px] overflow-hidden relative border-t border-[#ffffff14]">
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes scroll-infinite {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        .animate-scroll-infinite {
          animation: scroll-infinite 40s linear infinite;
        }
        .group:hover .animate-scroll-infinite {
          animation-play-state: paused;
        }
      `}} />
      <div className="w-full max-w-7xl mx-auto px-4">
        {/* Section Header */}
         <div className="flex flex-col items-center gap-[10px] mb-[40px]">
            <h2 className="text-[24px] sm:text-[36px] lg:text-[48px] font-semibold text-center text-[#ffffff]" style={{ fontFamily: 'Raleway' }}>
              O que dizem sobre nós
            </h2>
          </div>

        {/* Marquee Container */}
        <div className="relative w-full">
          {/* Gradient Fade Overlays */}
          <div className="absolute inset-y-0 left-0 w-20 sm:w-32 bg-gradient-to-r from-[#02020c] to-transparent z-10 pointer-events-none"></div>
          <div className="absolute inset-y-0 right-0 w-20 sm:w-32 bg-gradient-to-l from-[#02020c] to-transparent z-10 pointer-events-none"></div>

          {/* Marquee Track */}
          <div className="flex overflow-hidden select-none group">
            {/* First Set of Cards */}
            <div className="flex shrink-0 gap-[20px] w-max animate-scroll-infinite pr-[20px]">
              {doubledTestimonials.map((item, index) => {
                const IconComponent = IconMap[item.icon as keyof typeof IconMap];
                return (
                  <div 
                    key={`t1-${index}`}
                    className="w-[300px] sm:w-[350px] bg-white/5 border border-white/10 rounded-xl backdrop-blur-sm p-5 flex flex-col gap-4 shrink-0 hover:bg-white/10 transition-colors duration-300"
                  >
                    {/* Header: Avatar + Name + Role */}
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold shrink-0">
                        {item.name.charAt(0)}
                      </div>
                      <div className="flex flex-col">
                        <span className="text-white font-bold text-sm" style={{ fontFamily: 'Raleway' }}>{item.name}</span>
                        <div className="flex items-center gap-1">
                          <span className="text-gray-400 text-xs" style={{ fontFamily: 'Raleway' }}>{item.role}</span>
                          {IconComponent && <IconComponent size={12} className="text-blue-400" />}
                        </div>
                      </div>
                      <span className="ml-auto text-gray-500 text-xs" style={{ fontFamily: 'Raleway' }}>{item.date}</span>
                    </div>
                    
                    {/* Content */}
                    <p className="text-gray-300 text-sm leading-relaxed" style={{ fontFamily: 'Raleway' }}>
                      {item.text}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Second Set of Cards (Duplicate for Loop) */}
            <div className="flex shrink-0 gap-[20px] w-max animate-scroll-infinite pr-[20px]" aria-hidden="true">
              {doubledTestimonials.map((item, index) => {
                const IconComponent = IconMap[item.icon as keyof typeof IconMap];
                return (
                  <div 
                    key={`t2-${index}`}
                    className="w-[300px] sm:w-[350px] bg-white/5 border border-white/10 rounded-xl backdrop-blur-sm p-5 flex flex-col gap-4 shrink-0 hover:bg-white/10 transition-colors duration-300"
                  >
                     {/* Header: Avatar + Name + Role */}
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold shrink-0">
                        {item.name.charAt(0)}
                      </div>
                      <div className="flex flex-col">
                        <span className="text-white font-bold text-sm" style={{ fontFamily: 'Raleway' }}>{item.name}</span>
                        <div className="flex items-center gap-1">
                          <span className="text-gray-400 text-xs" style={{ fontFamily: 'Raleway' }}>{item.role}</span>
                          {IconComponent && <IconComponent size={12} className="text-blue-400" />}
                        </div>
                      </div>
                      <span className="ml-auto text-gray-500 text-xs" style={{ fontFamily: 'Raleway' }}>{item.date}</span>
                    </div>
                    
                    {/* Content */}
                    <p className="text-gray-300 text-sm leading-relaxed" style={{ fontFamily: 'Raleway' }}>
                      {item.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
